export const URI_BASE_API = "https://admindelivery.comunidadeppg.com.br/api/";
export const API_VERSION = "v1";
export const TOKEN_NAME = "token_sanctum_staff";
export const SOCKET_URL = "https://admindelivery.comunidadeppg.com.br";
